export const navigation = [
  {
    title: 'Welcome',
    url: '/welcome'
  }
];